<!-- <div id="confirmDialogModal" class="modal" [ngClass]="{ show: isVisible }">
  <div class="modal-content">
    <h2>Confirm Action</h2>
    <p class="modal-message">
     {{ message }} ?
    </p>
    <div class="butt">
      <button class="btn-confirm" (click)="onConfirm()">Confirm</button>
      <button class="btn-cancel"  (click)="closeDialog()">Cancel</button>
    </div>
  </div>
</div>

<div id="confirmDialogModal" class="modal" [ngClass]="{ show: isVisible }">
  <div class="modal-content">
    <h2>Confirm Action</h2>
    <p class="modal-message">
     {{ message }} ?
    </p>
    <div class="butt">
      <button class="btn btn-danger" (click)="onConfirm()">Confirm</button>
      <button class="btn btn-secondary" (click)="closeDialog()">Cancel</button>
    </div>
  </div>
</div>


<div id="confirmDialogModal" class="modal" [ngClass]="{ show: isVisible }">
  <div class="modal-content">
    <h2>Confirm Action</h2>
     <p class="modal-message">
     {{ message }} ?
    </p>
    <div class="butt">
      <button class="btn btn-danger" (click)="onConfirm()">Confirm</button>
      <button class="btn btn-secondary" (click)="cloialog()">Cancel</button>
    </div>
  </div>
</div> -->

<!-- Modal Overlay Wrapper -->
<div class="modal-overlay" *ngIf="isVisible">
  <div class="card" style="width: 35rem;">
    <div class="card-body">

      <!-- Only show the <img> if imageUrl is set -->
      <div class="d-flex justify-content-center" >
        <img [src]="imageUrl" alt="Confirmation icon" style="padding: 14px;" />
      </div>

      <!-- Message -->
      <div class="textarea" style="background-color: #F8F8F8; width: 100%;">
        <p class="card-text" [innerHTML]="message"></p>

        <!-- Buttons -->
        <div class="d-flex justify-content-center">
          <span>
            <button class="cancel" (click)="closeDialog()">Cancel</button>
            <button class="confirm" (click)="onConfirm()">Confirm</button>
          </span>
        </div>
      </div>
      
    </div>
  </div>
</div>

 
<!-- 
<div class="modal-overlay" *ngIf="isVisible">
  <div class="card confirmation-card">
    <div class="card-body">
       Image 
      <div class="d-flex justify-content-center">
        <img src="/assets/confirmation-msg/frame.png" style="padding: 14px;" />
      </div>

      Message 
      <div class="textarea" style="background-color: #F8F8F8; width: 100%;">
        <p class="card-text">{{ message }}</p>
      </div>

       Buttons 
      <div class="d-flex justify-content-center gap-3 mt-3">
        <button class="cancel btn btn-secondary px-4" (click)="closeDialog()">Cancel</button>
        <button class="confirm btn btn-danger px-4" (click)="onConfirm()">Confirm</button>
      </div>
    </div>
  </div>
</div>  -->
